export const MAX_ATTACHMENTS = 5;
export const MAX_ATTACHMENT_SIZE = 10 * 1024 * 1024; // 10MB - Email/SMS provider limit
export const MAX_INTERNAL_NOTE_FILE_SIZE = 100 * 1024 * 1024; // 100MB - S3 direct upload

export const DEBOUNCE_DELAY = 300;
export const MIN_SEARCH_LENGTH = 2;
export const MAX_AUTOCOMPLETE_RESULTS = 10;

// Shared sender email addresses
export const SHARED_SENDER_EMAILS = [
  { email: 'support@ergeon.com', label: 'support@ergeon.com', defaultDisplayName: 'Ergeon Support' },
  { email: 'contact@ergeon.com', label: 'contact@ergeon.com', defaultDisplayName: 'Ergeon' },
];

// Predefined display name options
export const DISPLAY_NAME_OPTIONS = [
  { value: 'Ergeon Support', label: 'Ergeon Support' },
  { value: 'Ergeon', label: 'Ergeon' },
];

// Default values - shared email by default, personal is exception
export const DEFAULT_SENDER_EMAIL = 'support@ergeon.com';
export const DEFAULT_DISPLAY_NAME = 'Ergeon Support';
